import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Container, Box, Grid } from "@material-ui/core";
import Table from '../Common/table';
import PaginationRounded from '../Common/PaginationRounded';
import Loading from "../Common/loading";
import EditCompanyForm from './EditCompanyForm';
import ListOfUsers from './ListOfUsers';
import SMSYearToDate from './SMSYearToDate';
import AlertDialog from '../Alerts/AlertDialog';
import ConfirmDialog from '../Alerts/ConfirmDialog';
import API from "../../actions";


const Companies = props => {

    const [therapists, setTherapists] = useState([]);
    const [openLoading, setOpenLoading] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: "companyName", order: "asc" });
    const [pageNumber, setPageNumber] = useState(1);
    const [pageTotal, setPageTotal] = useState(0);
    const [sortedCompanies, setSortedCompanies] = useState([]);
    const [dialogCompanyOpen, setDialogCompanyOpen] = useState(false);
    const [dialogListUsersOpen, setDialogListUsersOpen] = useState(false);
    const [dialogSMSYearToDateOpen, setDialogSMSYearToDateOpen] = useState(false);
    const [editingCompany, setEditingCompany] = useState({});
    const [alert, setAlert] = useState({ title: '', openStatus: false, message: '' });
    const [confirm, setConfirm] = useState({ title: '', openStatus: false, message: '', data: null });

    const loadData = async () => {
        setOpenLoading(true);
        try {
            const data = await API.getCompaniesSuperadmin(sortColumn.order, sortColumn.path, pageNumber);
            setSortedCompanies(data.data);
            setPageTotal(Math.ceil(data.total.total / 10));
        } catch (err) {
            setAlert({ ...alert, ...{ openStatus: true, message: err ? err : 'Kan ikke oprette forbindelse til serveren. Prøv igen.' } });
        }
        setOpenLoading(false);
    }

    useEffect(() => {
        loadData();
    }, [pageNumber]);

    useEffect(() => {
        loadData();
    }, [sortColumn]);


    const columns = [
        { path: "companyName", label: "Firmanavn", type: "TextLink" },
        { path: "contactPersion", label: "Kontaktperson", type: "alpha" },
        { path: "email", label: "Kontormail", type: "alpha" },
        { path: "phone", label: "Kontortelefon", type: "alpha" },
        { path: "users", label: "Antal bruger", type: "TextLink" },
        { path: "createdAt", label: "Registrerings dato", type: "Date" },
        { path: "payment", label: "Betaling", type: "payment" },
        { path: "reepayReminderDate", label: "Påmindelse afsendt", type: "ReepayReminder" },
        { path: "smsytd", label: "SMS YTD", type: "TextLink" },
        { path: "isDisabled", label: "Action", type: "Action", sorting: false },
    ];

    const handleSort = sortColumn => {
        setSortColumn(sortColumn);
    };

    const handleSwitchChange = (event, id) => {
        // console.log('handleSwitchChange', event, id);
    };

    const handleChangePage = async (event, page) => {
        setPageNumber(page);
    };

    const handleCellClick = (event, item, column) => {
        // console.log('handleCellClick', event, item, column);
        setEditingCompany(item);

        if (column.path === 'companyName') {
            setDialogCompanyOpen(true);
        } else if (column.path === 'users') {
            setDialogListUsersOpen(true);
        } else if (column.path === 'smsytd') {
            setDialogSMSYearToDateOpen(true);
        } else if (column.path === 'isDisabled') {
            if (event === 'delete') {
                setConfirm({
                    ...confirm, ...{
                        title: 'Slet firma', data: item, openStatus: true,
                        message: `Er du sikker på at du vil slette ${item.companyName} bruger/klinik?`
                    }
                });
            } else if (event === 'OnOff') {
                setOnOffCompany(item);
            }
        }
    };

    if (!therapists) {
        return <div></div>;
    }

    const handleCompanyClose = () => {
        setDialogCompanyOpen(false)
    }
    const handleSaveCompanySuccess = () => {
        setDialogCompanyOpen(false);
        setAlert({ ...alert, ...{ openStatus: true, message: 'Virksomhed opdateret med succes.' } });
        loadData();
    }
    const handleListUsersClose = () => {
        setDialogListUsersOpen(false);
    }
    const handleSMSYearToDateOpenClose = () => {
        setDialogSMSYearToDateOpen(false);
    }
    const handleAlertOnClose = () => {
        setAlert({ ...alert, ...{ openStatus: false } });
    }
    const handleConfirmOnClose = () => {
        setConfirm({ ...confirm, ...{ openStatus: false } });
    }
    const handDeleteConfirm = async (data) => {
        setConfirm({ ...confirm, ...{ openStatus: false } });
        setOpenLoading(true);
        // console.log('handDeleteConfirm', data);

        // delete company
        try {
            await API.deleteCompany(data.id);
            setAlert({ ...alert, ...{ openStatus: true, message: 'Virksomheden er blevet slettet.' } });
            loadData();
        } catch (err) {
            setAlert({ ...alert, ...{ openStatus: true, message: err ? err : 'Kan ikke oprette forbindelse til serveren. Prøv igen.' } });
        }
        setOpenLoading(false);
    };

    const setOnOffCompany = async (item) => {
        try {
            await API.disableCompany(item.id, !item.isDisabled);
            setAlert({ ...alert, ...{ openStatus: true, message: 'Virksomhedens nye status er opdateret med succes.' } })
            loadData();

        } catch (err) {
            setAlert({ ...alert, ...{ openStatus: true, message: err ? err : 'Kan ikke oprette forbindelse til serveren. Prøv igen.' } });
        }
    }

    return (
        <>
            <Container maxWidth="xl">
                <Grid>
                    <Box my={3}>
                        <div className="box rounded shadown">
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    onSort={handleSort}
                                    sortColumn={sortColumn}
                                    data={sortedCompanies}
                                    handleSwitchChange={handleSwitchChange}
                                    onCellClick={handleCellClick}
                                />
                            </div>
                        </div>
                        <PaginationRounded total={pageTotal} onChangePage={handleChangePage} />
                    </Box>

                </Grid>
            </Container>

            <EditCompanyForm company={editingCompany} dialogOpen={dialogCompanyOpen} onClose={handleCompanyClose} onSaveSuccess={handleSaveCompanySuccess} />
            <ListOfUsers company={editingCompany} dialogOpen={dialogListUsersOpen} onClose={handleListUsersClose} />
            <SMSYearToDate company={editingCompany} dialogOpen={dialogSMSYearToDateOpen} onClose={handleSMSYearToDateOpenClose} />
            <AlertDialog
                title={alert.title}
                openStatus={alert.openStatus}
                onClose={handleAlertOnClose}
                message={alert.message} />
            <ConfirmDialog title={confirm.title}
                openStatus={confirm.openStatus}
                message={confirm.message}
                data={confirm.data}
                onConfirm={handDeleteConfirm}
                onClose={handleConfirmOnClose}
                buttonConfirm="Slet" />
            <Loading open={openLoading} />
        </>
    );
};

export default Companies;
